/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LaborIncident from './labor-incident';
import LaborIncidentDetail from './labor-incident-detail';
import LaborIncidentUpdate from './labor-incident-update';
import LaborIncidentDeleteDialog from './labor-incident-delete-dialog';

const LaborIncidentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LaborIncident />} />
    <Route path="new" element={<LaborIncidentUpdate />} />
    <Route path=":id">
      <Route index element={<LaborIncidentDetail />} />
      <Route path="edit" element={<LaborIncidentUpdate />} />
      <Route path="delete" element={<LaborIncidentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LaborIncidentRoutes;
